import AppContext from "PFApp/app_context";
import { useDownloadTextFile } from "PFCore/helpers/use_download_text_file";
import { useApproveCustomValues } from "PFCore/hooks/queries/custom_fields/admin/custom_values_bulk/use_approve_custom_values";
import { useBlacklistCustomValues } from "PFCore/hooks/queries/custom_fields/admin/custom_values_bulk/use_blacklist_custom_values";
import { useDeleteCustomValues } from "PFCore/hooks/queries/custom_fields/admin/custom_values_bulk/use_delete_custom_values";
import { useExportCustomValues } from "PFCore/hooks/queries/custom_fields/admin/custom_values_bulk/use_export_custom_values";
import { useResetCustomValues } from "PFCore/hooks/queries/custom_fields/admin/custom_values_bulk/use_reset_custom_values";
import { CURRENT_PROFILE_ASYNC_ACTIONS } from "PFReducers/current_profile_reducer";
import { useContext } from "react";

import { useBulkResponseHandler } from "./use_bulk_response_handler";

export const useSkillActions = () => {
  const handleResponse = useBulkResponseHandler();
  const download = useDownloadTextFile();
  const { dispatch } = useContext(AppContext);
  const { mutateAsync: approveSkills } = useApproveCustomValues({
    onSuccess: (response) => {
      handleResponse(response);
      dispatch({
        type: CURRENT_PROFILE_ASYNC_ACTIONS.CURRENT_PROFILE_FETCH
      });
    }
  });
  const { mutateAsync: blacklistSkills } = useBlacklistCustomValues({
    onSuccess: (response) => {
      handleResponse(response);
      dispatch({
        type: CURRENT_PROFILE_ASYNC_ACTIONS.CURRENT_PROFILE_FETCH
      });
    }
  });
  const { mutateAsync: deleteSkills } = useDeleteCustomValues({
    onSuccess: (response) => {
      handleResponse(response);
      dispatch({
        type: CURRENT_PROFILE_ASYNC_ACTIONS.CURRENT_PROFILE_FETCH
      });
    }
  });
  const { mutateAsync: resetSkills } = useResetCustomValues({
    onSuccess: (response) => handleResponse(response)
  });
  const { mutateAsync: exportSkills } = useExportCustomValues({
    onSuccess: (data) => download("skills.csv", data)
  });

  return {
    approveSkills,
    blacklistSkills,
    resetSkills,
    deleteSkills,
    exportSkills
  };
};
